document.addEventListener("DOMContentLoaded", function () {
  const productSliderCategorySelections = document.querySelectorAll(
    ".product_slider .product_slider_categories_container div[data-collection]"
  );
  const productSliders = document.querySelectorAll(
    ".product_slider slider-component"
  );
  productSliderCategorySelections?.forEach(function (item) {
    item.addEventListener("click", function () {
      const selectedCategory = this.getAttribute("data-collection");

      productSliderCategorySelections.forEach(category => category.classList.remove("active"));

      item.classList.add("active");
      
      productSliders?.forEach(function (slider) {
        const sliderCategory = slider.getAttribute("data-collection");
        
        if (
          sliderCategory &&
          sliderCategory === selectedCategory &&
          !slider.classList.contains("active")
        ) {
          slider.classList.add("active");
        } else if (sliderCategory && sliderCategory !== selectedCategory) {
          slider.classList.remove("active");
        }
      });
    });
  });
});
